'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var multiaddr = require('multiaddr');

function createClear(_ref) {
  var repo = _ref.repo;

  function clear() {
    return _clear.apply(this, arguments);
  }

  function _clear() {
    _clear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          config,
          removed,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.next = 3;
              return repo.config.getAll(options);

            case 3:
              config = _context.sent;
              removed = config.Bootstrap || [];
              config.Bootstrap = [];
              _context.next = 8;
              return repo.config.replace(config);

            case 8:
              return _context.abrupt("return", {
                Peers: removed.map(function (ma) {
                  return new multiaddr.Multiaddr(ma);
                })
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _clear.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(clear);
}

exports.createClear = createClear;